/** Object representing an empty one-to-one relationship in JSON:API */
export const EMPTY_TO_ONE = {
  data: null,
}
